<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="user">
            <ValidationObserver ref="employmentform">
                <form @submit.prevent="saveEmployment">
                    <div class="row">
                        <div class="col-xl-10">
                            <div class="row">
                                <label class="col-form-label col-xl-2">Anställd i:</label>
                                <div class="col-xl-10">
                                    <ValidationProvider tag="div" class="form-group" vid="company_id" name="Företag" rules="required" v-slot="{ errors }">
                                        <company-filter
                                            v-model="user.company_id"
                                            placeholder="Välj företag..."
                                            :reduce="opt => opt.id"
                                            :class="{'has-validation-error':(!!errors[0])}"
                                        ></company-filter>
                                        <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Titel/Anvsvar:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="workTitle" name="Titel/Anvsvar" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.workTitle" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Anställd fr.o.m.:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="EmploymentStartTS" name="Anställd fr.o.m" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <v-date-picker v-model="user.EmploymentStartTS" mode="date" :model-config="{ type: 'string', mask: 'iso' }" :masks="{ input: 'YYYY-MM-DD' }">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class="input-group">
                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                    <span class="input-group-append">
                                                        <button class="btn btn-light" type="button" @click="user.EmploymentStartTS = ''"><i class="icon-cross3"></i></button>
                                                    </span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Anställd t.o.m.:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="EmploymentEndTS" name="Anställd t.o.m" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <v-date-picker v-model="user.EmploymentEndTS" mode="date" :model-config="{ type: 'string', mask: 'iso' }" :masks="{ input: 'YYYY-MM-DD' }">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class="input-group">
                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                    <span class="input-group-append">
                                                        <button class="btn btn-light" type="button" @click="user.EmploymentEndTS = ''"><i class="icon-cross3"></i></button>
                                                    </span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Primär Arbetsplats:</label>
                                <div class="col-xl-10" style="padding-top: calc(0.4375rem + 1px);">
                                    <ValidationProvider tag="div" class="form-group" vid="workplace_type" name="Arbetsplats" rules="required">
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" class="custom-control-input" v-model="user.workplace_type" id="wp_t_office" value="office" :disabled="!hasPermission('red_edit_all_users')">
                                            <label class="custom-control-label" for="wp_t_office">Kontor</label>
                                        </div>
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" class="custom-control-input" v-model="user.workplace_type" id="wp_t_store" value="store" :disabled="!hasPermission('red_edit_all_users')">
                                            <label class="custom-control-label" for="wp_t_store">Butik</label>
                                        </div>
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" class="custom-control-input" v-model="user.workplace_type" id="wp_t_warehouse" value="warehouse" :disabled="!hasPermission('red_edit_all_users')">
                                            <label class="custom-control-label" for="wp_t_warehouse">Lager</label>
                                        </div>
                                    </ValidationProvider>
                                    <ValidationProvider tag="div" class="form-group" vid="StoreID" name="Arbetsplats" rules="" v-slot="{ errors }">
                                        <store-filter
                                            :filter="(opt) => opt.is_workplace"
                                            v-model="user.StoreID"
                                            placeholder="Välj arbetsplats..."
                                            label="StoreName"
                                            :reduce="opt => opt.StoreID"
                                            :class="{'has-validation-error':(!!errors[0])}"
                                            :disabled="!hasPermission('red_edit_all_users')"
                                        ></store-filter>
                                        <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Arbetsplatser:</label>
                                <div class="col-xl-10">
                                    <ValidationProvider tag="div" class="form-group" vid="store_ids" name="Arbetsplats" rules="" v-slot="{ errors }">
                                        <store-filter
                                            :filter="(opt) => opt.is_workplace"
                                            v-model="user.store_ids"
                                            placeholder="Välj butiker..."
                                            label="StoreName"
                                            :reduce="opt => opt.StoreID"
                                            :class="{'has-validation-error':(!!errors[0])}"
                                            multiple
                                            :disabled="!hasPermission('red_edit_all_users')"
                                        ></store-filter>
                                        <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Grupper:</label>
                                <div class="col-xl-10">
                                    <ValidationProvider tag="div" class="form-group" vid="group_ids" name="Grupper" rules="" v-slot="{ errors }">
                                        <user-group-filter
                                            v-model="user.group_ids"
                                            placeholder="Välj grupper..."
                                            label="name"
                                            :reduce="opt => opt.id"
                                            :class="{'has-validation-error':(!!errors[0])}"
                                            multiple
                                            :disabled="!hasPermission('red_edit_all_users')"
                                        ></user-group-filter>
                                        <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Ansvarig för anställda i grupper:</label>
                                <div class="col-xl-10">
                                    <ValidationProvider tag="div" class="form-group" vid="in_charge_of_group_ids" name="Grupper" rules="" v-slot="{ errors }">
                                        <user-group-filter
                                            v-model="user.in_charge_of_group_ids"
                                            placeholder="Välj grupper..."
                                            label="name"
                                            :reduce="opt => opt.id"
                                            :class="{'has-validation-error':(!!errors[0])}"
                                            multiple
                                            :disabled="!hasPermission('red_edit_users_permissions')"
                                        ></user-group-filter>
                                        <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Flaggor:</label>
                                <div class="col-xl-4" style="padding-top: calc(0.4375rem + 1px);">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox mb-2">
                                            <input id="chk-isSeller" type="checkbox" class="custom-control-input" v-model="user.isSeller" :true-value="1" :false-value="0">
                                            <label for="chk-isSeller" class="custom-control-label">Är Supékort-säljare</label>
                                        </div>
                                        <div class="custom-control custom-checkbox mb-2">
                                            <input id="chk-worksInNPHome" type="checkbox" class="custom-control-input" v-model="user.worksInNPHome" :true-value="1" :false-value="0">
                                            <label for="chk-worksInNPHome" class="custom-control-label">Är NP Home-säljare</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasPermission('red_fortnox_integration') && user.workplace_type !== 'store'"
                                class="row mt-4"
                            >
                                <label class="col-form-label col-xl-2">OB:</label>
                                <div class="col-xl-6" style="padding-top: calc(0.4375rem + 1px);">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox mb-2">
                                            <input v-if="user.workplace_type === 'warehouse'" id="chk-ob_weekends" type="checkbox" class="custom-control-input" checked disabled>
                                            <input v-else id="chk-ob_weekends" type="checkbox" class="custom-control-input" v-model="user.ob_weekends" :true-value="1" :false-value="0">
                                            <label for="chk-ob_weekends" class="custom-control-label">OB på helger (lördag, söndag, röda dagar, helgdagar)</label>
                                        </div>
                                        <div class="custom-control custom-checkbox mb-2">
                                            <input id="chk-ob_weekdays" type="checkbox" class="custom-control-input" v-model="user.ob_weekdays" :true-value="1" :false-value="0">
                                            <label for="chk-ob_weekdays" class="custom-control-label">OB på vardagar (måndag-fredag efter kl. 18.00)</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2">
                                    <ValidationProvider tag="div" class="form-group" vid="ob_from" name="Anställd fr.o.m" rules="" v-slot="{ errors }">
                                        <label>OB fr.o.m:</label>
                                        <v-date-picker v-model="user.ob_from" mode="date" :model-config="{ type: 'string', mask: 'iso' }" :masks="{ input: 'YYYY-MM-DD' }">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class="input-group">
                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                    <span class="input-group-append">
                                                <button class="btn btn-light" type="button" @click="user.ob_from = ''"><i class="icon-cross3"></i></button>
                                            </span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-2">
                                    <ValidationProvider tag="div" class="form-group" vid="ob_to" name="Anställd fr.o.m" rules="" v-slot="{ errors }">
                                        <label>OB t.o.m:</label>
                                        <v-date-picker v-model="user.ob_to" mode="date" :model-config="{ type: 'string', mask: 'iso' }" :masks="{ input: 'YYYY-MM-DD' }">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class="input-group">
                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                    <span class="input-group-append">
                                                <button class="btn btn-light" type="button" @click="user.ob_to = ''"><i class="icon-cross3"></i></button>
                                            </span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div v-if="hasPermission('red_fortnox_integration')">
                                <div class="row mt-4">
                                    <label class="col-form-label col-xl-2">Fortnox lönehantering:</label>
                                    <div class="col-xl-10">
                                        <ValidationProvider tag="div" class="form-group" vid="FortnoxSalaryType" name="Lönehantering" rules="" v-slot="{ errors }">
                                            <v-select
                                                :options="select_salary_types"
                                                v-model="user.FortnoxSalaryType"
                                                placeholder="--- INGEN LÖNEHANTERING ---"
                                                :reduce="opt => opt.id"
                                                :class="{'has-validation-error':(!!errors[0])}"
                                            ></v-select>
                                            <span v-if="errors[0]" class="form-text text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-xl-2">Fortnox Anställnings-ID:</label>
                                    <ValidationProvider tag="div" class="col-xl-10" vid="fortnox_id" name="Anställnings-ID" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="user.fortnox_id" v-bind:class="{ 'border-danger':errors[0] }">
                                                <div class="input-group-append">
                                                    <limitless-button btn-class="btn-light" @click="registerInFortnox(false)" ref="btnregisterfortnox" saved-text="REGISTRERAD!">Registrera i Fortnox</limitless-button>
                                                </div>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-xl-2">NK Anställnings-ID:</label>
                                    <ValidationProvider tag="div" class="col-xl-10" vid="fortnox_id_extra" name="Anställnings-ID" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="user.fortnox_id_extra" v-bind:class="{ 'border-danger':errors[0] }">
                                                <div class="input-group-append">
                                                    <limitless-button btn-class="btn-light" @click="registerInFortnox(true)" ref="btnregisterfortnoxnk" saved-text="REGISTRERAD!">Registrera i Fortnox</limitless-button>
                                                </div>
                                            </div>
                                            <span v-if="!!(errors[0])" class="validation-invalid-label">{{ errors[0] }}</span>
                                            <div v-else class="text-muted">SPECIAL - Använd endast om personen även är anställd i NK utöver Supekort/Newport</div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveemployment" type="button" @click="saveEmployment" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import vSelect from 'vue-select';
import { hasPermission } from '@services/Helpers';
import CompanyFilter from '@components/Filters/CompanyFilter.vue';
import StoreFilter from '@components/Filters/StoreFilter.vue';
import UserGroupFilter from '@components/Filters/UserGroupFilter.vue';

export default {
    components: {
        UserGroupFilter,
        StoreFilter,
        CompanyFilter,
        vSelect,
        VDatePicker,
        LimitlessButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        not_found: false,
        user: null,
        select_salary_types: [
            {
                id: 1,
                label: 'Fortnox månadslön',
            },
            {
                id: 2,
                label: 'Fortnox timlön',
            },
        ],
    }),
    mounted() {
        this.getUser();
    },
    methods: {
        hasPermission,
        getUser() {
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.user = response.data.user;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveEmployment() {
            const isValid = await this.$refs.employmentform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id + '/employment', this.user)
                    .then((response) => {
                        this.user = response.data.user;
                        this.$refs.btnsaveemployment.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.employmentform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveemployment.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        registerInFortnox(nk = false) {
            apiClient.post('/vue/users/' + this.user.UserID + '/register_in_fortnox', { nk })
                .then((response) => {
                    this.user = response.data.user;
                    if (nk) {
                        this.$refs.btnregisterfortnoxnk.triggerSaved();
                    } else {
                        this.$refs.btnregisterfortnox.triggerSaved();
                    }
                })
                .catch(() => {
                    if (nk) {
                        this.$refs.btnregisterfortnoxnk.triggerFailed();
                    } else {
                        this.$refs.btnregisterfortnox.triggerFailed();
                    }
                });
        },
    },
};

</script>
